import { createImageUpload } from '@/components/tiptap-editor/plugins'
import { onUpload, onValidate } from '@/lib/image/uploader'

export const uploadFn = createImageUpload({
  onUpload: onUpload,
  validateFn: onValidate,
})
